/**
 * THE LIST A TICKET WAS OPENED FROM, so the ticket page can offer the
 * previous and next ticket in it ([ and ], and the arrows in its header).
 *
 * The lists link with plain hrefs, so nothing travels in the router's state;
 * each list leaves the order it is showing in this tab's sessionStorage
 * instead, and the ticket page reads it. Per tab, so two tabs on two lists do
 * not tread on each other, and gone when the tab closes. Every read and write
 * is guarded: a private window may refuse storage, and then there is simply
 * no previous or next.
 */
const KEY = 'jarvis-ticket-order';

export function rememberOrder(ids) {
  try {
    const list = (ids || []).map(String).filter(Boolean).slice(0, 500);
    sessionStorage.setItem(KEY, JSON.stringify(list));
  } catch { /* storage refused: no prev/next, nothing else lost */ }
}

/** { prev, next } around this ticket in the remembered list, or nulls. */
export function neighbours(id) {
  try {
    const list = JSON.parse(sessionStorage.getItem(KEY) || '[]');
    const at = Array.isArray(list) ? list.indexOf(String(id)) : -1;
    if (at < 0) return { prev: null, next: null, at: -1, total: 0 };
    return { prev: list[at - 1] || null, next: list[at + 1] || null, at, total: list.length };
  } catch {
    return { prev: null, next: null, at: -1, total: 0 };
  }
}
